import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as selectApi from "lib/api/selectData";

// 가입 경로
const JOINPATHCD = "select/JOINPATHCD";
const JOINPATHCD_PENDING = "select/JOINPATHCD_PENDING";
const JOINPATHCD_SUCCESS = "select/JOINPATHCD_SUCCESS";

// 선호하는 연락방법 1~5
const PREFERCONTACTCD1 = "select/PREFERCONTACTCD1";
const PREFERCONTACTCD1_PENDING = "select/PREFERCONTACTCD1_PENDING";
const PREFERCONTACTCD1_SUCCESS = "select/PREFERCONTACTCD1_SUCCESS";

const PREFERCONTACTCD2 = "select/PREFERCONTACTCD2";
const PREFERCONTACTCD2_PENDING = "select/PREFERCONTACTCD2_PENDING";
const PREFERCONTACTCD2_SUCCESS = "select/PREFERCONTACTCD2_SUCCESS";

const PREFERCONTACTCD3 = "select/PREFERCONTACTCD3";
const PREFERCONTACTCD3_PENDING = "select/PREFERCONTACTCD3_PENDING";
const PREFERCONTACTCD3_SUCCESS = "select/PREFERCONTACTCD3_SUCCESS";

const PREFERCONTACTCD4 = "select/PREFERCONTACTCD4";
const PREFERCONTACTCD4_PENDING = "select/PREFERCONTACTCD4_PENDING";
const PREFERCONTACTCD4_SUCCESS = "select/PREFERCONTACTCD4_SUCCESS";

const PREFERCONTACTCD5 = "select/PREFERCONTACTCD5";
const PREFERCONTACTCD5_PENDING = "select/PREFERCONTACTCD5_PENDING";
const PREFERCONTACTCD5_SUCCESS = "select/PREFERCONTACTCD5_SUCCESS";

// 민족
const LANGCD = "select/LANGCD";
const LANGCD_PENDING = "select/LANGCD_PENDING";
const LANGCD_SUCCESS = "select/LANGCD_SUCCESS";

// 자원 부문
const SBJCONDCD = "select/SBJCONDCD";
const SBJCONDCD_PENDING = "select/SBJCONDCD_PENDING";
const SBJCONDCD_SUCCESS = "select/SBJCONDCD_SUCCESS";

// 흡연여부
const SMOKEYN = "select/SMOKEYN";
const SMOKEYN_PENDING = "select/SMOKEYN_PENDING";
const SMOKEYN_SUCCESS = "select/SMOKEYN_SUCCESS";

// 병력
const SICKCD = "select/SICKCD";
const SICKCD_PENDING = "select/SICKCD_PENDING";
const SICKCD_SUCCESS = "select/SICKCD_SUCCESS";

// 질환구분
const CENTERCD = "select/CENTERCD";
const CENTERCD_PENDING = "select/CENTERCD_PENDING";
const CENTERCD_SUCCESS = "select/CENTERCD_SUCCESS";

// 대상질환
const DISASESCD = "select/DISASESCD";
const DISASESCD_PENDING = "select/DISASESCD_PENDING";
const DISASESCD_SUCCESS = "select/DISASESCD_SUCCESS";

// 암종
const CENCERCD = "select/CENCERCD";
const CENCERCD_PENDING = "select/CENCERCD_PENDING";
const CENCERCD_SUCCESS = "select/CENCERCD_SUCCESS";

// 임상시험 종류
const SBJTYCD = "select/SBJTYCD";
const SBJTYCD_PENDING = "select/SBJTYCD_PENDING";
const SBJTYCD_SUCCESS = "select/SBJTYCD_SUCCESS";

//
const ENTRYMONTH = "select/ENTRYMONTH";
const ENTRYMONTH_PENDING = "select/ENTRYMONTH_PENDING";
const ENTRYMONTH_SUCCESS = "select/ENTRYMONTH_SUCCESS";

export const joinPathCd = createPromiseThunk(JOINPATHCD, selectApi.joinPathCd); // 가입경로

// 선호하는 연락방법 1~5
export const preferContactCd1 = createPromiseThunk(
  PREFERCONTACTCD1,
  selectApi.preferContactCd1
);
export const preferContactCd2 = createPromiseThunk(
  PREFERCONTACTCD2,
  selectApi.preferContactCd2
);
export const preferContactCd3 = createPromiseThunk(
  PREFERCONTACTCD3,
  selectApi.preferContactCd3
);
export const preferContactCd4 = createPromiseThunk(
  PREFERCONTACTCD4,
  selectApi.preferContactCd4
);
export const preferContactCd5 = createPromiseThunk(
  PREFERCONTACTCD5,
  selectApi.preferContactCd5
);

export const langCd = createPromiseThunk(LANGCD, selectApi.langCd); // 민족
export const sbjCondCd = createPromiseThunk(SBJCONDCD, selectApi.sbjCondCd); // 자원 부문
export const smokeYn = createPromiseThunk(SMOKEYN, selectApi.smokeYn); // 자원 부문
export const sickCd = createPromiseThunk(SICKCD, selectApi.sickCd); // 병력
export const centerCd = createPromiseThunk(CENTERCD, selectApi.centerCd); // 질환구분
export const disasesCd = createPromiseThunk(DISASESCD, selectApi.disasesCd); // 대상질환
export const cencerCd = createPromiseThunk(CENCERCD, selectApi.cencerCd); // 암종
export const sbjTyCd = createPromiseThunk(SBJTYCD, selectApi.sbjTyCd); // 임상시험 종류
export const entryMonth = createPromiseThunk(ENTRYMONTH, selectApi.entryMonth); // 참여 가능 기간

const initialState = {
  joinPathData: [],
  preferContactData1: [],
  preferContactData2: [],
  preferContactData3: [],
  preferContactData4: [],
  preferContactData5: [],
  langData: [],
  sbjCondData: [],
  smokeYnData: [],
  sickData: [],
  centerData: [],
  disasesData: [],
  cencerData: [],
  sbjTyData: [],
  entryMonthData: []
};

export default handleActions(
  {
    [JOINPATHCD_PENDING]: (state, { payload }) => ({
      ...state,
      joinPathData: []
    }),
    [JOINPATHCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      joinPathData: payload.data
    }),
    [PREFERCONTACTCD1_PENDING]: (state, { payload }) => ({
      ...state,
      preferContactData1: []
    }),
    [PREFERCONTACTCD1_SUCCESS]: (state, { payload }) => ({
      ...state,
      preferContactData1: payload.data
    }),
    [PREFERCONTACTCD2_PENDING]: (state, { payload }) => ({
      ...state,
      preferContactData2: []
    }),
    [PREFERCONTACTCD2_SUCCESS]: (state, { payload }) => ({
      ...state,
      preferContactData2: payload.data
    }),
    [PREFERCONTACTCD3_PENDING]: (state, { payload }) => ({
      ...state,
      preferContactData3: []
    }),
    [PREFERCONTACTCD3_SUCCESS]: (state, { payload }) => ({
      ...state,
      preferContactData3: payload.data
    }),
    [PREFERCONTACTCD4_PENDING]: (state, { payload }) => ({
      ...state,
      preferContactData4: []
    }),
    [PREFERCONTACTCD4_SUCCESS]: (state, { payload }) => ({
      ...state,
      preferContactData4: payload.data
    }),
    [PREFERCONTACTCD5_PENDING]: (state, { payload }) => ({
      ...state,
      preferContactData5: []
    }),
    [PREFERCONTACTCD5_SUCCESS]: (state, { payload }) => ({
      ...state,
      preferContactData5: payload.data
    }),

    [LANGCD_PENDING]: (state, { payload }) => ({
      ...state,
      langData: []
    }),
    [LANGCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      langData: payload.data
    }),
    [SBJCONDCD_PENDING]: (state, { payload }) => ({
      ...state,
      sbjCondData: []
    }),
    [SBJCONDCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      sbjCondData: payload.data
    }),
    [SMOKEYN_PENDING]: (state, { payload }) => ({
      ...state,
      smokeYnData: []
    }),
    [SMOKEYN_SUCCESS]: (state, { payload }) => ({
      ...state,
      smokeYnData: payload.data
    }),
    [SICKCD_PENDING]: (state, { payload }) => ({
      ...state,
      sickData: []
    }),
    [SICKCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      sickData: payload.data
    }),
    [CENTERCD_PENDING]: (state, { payload }) => ({
      ...state,
      centerData: []
    }),
    [CENTERCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      centerData: payload.data
    }),
    [DISASESCD_PENDING]: (state, { payload }) => ({
      ...state,
      disasesData: []
    }),
    [DISASESCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      disasesData: payload.data
    }),
    [CENCERCD_PENDING]: (state, { payload }) => ({
      ...state,
      cencerData: []
    }),
    [CENCERCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      cencerData: payload.data
    }),
    [SBJTYCD_PENDING]: (state, { payload }) => ({
      ...state,
      sbjTyData: []
    }),
    [SBJTYCD_SUCCESS]: (state, { payload }) => ({
      ...state,
      sbjTyData: payload.data
    }),
    [ENTRYMONTH_PENDING]: (state, { payload }) => ({
      ...state,
      entryMonthData: []
    }),
    [ENTRYMONTH_SUCCESS]: (state, { payload }) => ({
      ...state,
      entryMonthData: payload.data
    })
  },
  initialState
);
